const VERSION = '2.0.9p'
export default VERSION
